import { animate, style, transition, trigger } from '@angular/animations';

// Fade animation for elements within components (shared across apps)
export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('400ms 150ms ease-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [animate('200ms ease-out', style({ opacity: 0 }))]),
]);
